import { render, staticRenderFns } from "./manageFunding.vue?vue&type=template&id=2ab78b08"
import script from "./manageFunding.vue?vue&type=script&lang=ts"
export * from "./manageFunding.vue?vue&type=script&lang=ts"
import style0 from "./manageFunding.vue?vue&type=style&index=0&id=2ab78b08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports